<script setup lang="ts"></script>

<template>
    <div class="mx-6 my-4 border-b border-gray-700"></div>
</template>
